import React from 'react';
import { withHandlers } from 'recompose';
import SearchInput from '../../SearchInput';
import ToolWindow from '../../ToolWindow';
import './SearchTool.css';

const SearchTool = ({
  icon,
  title,
  placeholder,
  filter,
  filterActive,
  children,
  onFilterChange,
  onFilterClear,
  onClose,
  handleSearchClick,
}) => {
  const inputClass = filterActive
    ? 'input'
    : 'input none';
  const searchClass = filterActive
    ? 'search active'
    : 'search';
  return (
    <ToolWindow
      icon={icon}
      title={title}
      actionBar={
        <div className="SearchToolActionBar">
          <button
            className={`fontawesome-search ${searchClass}`}
            onClick={handleSearchClick}
          />
        </div>
      }
      onClose={onClose}
    >
      <div className="SearchTool">
        <div className={inputClass}>
          <SearchInput
            placeholder={placeholder}
            value={filter}
            onChange={onFilterChange}
            onClear={onFilterClear}
          />
        </div>
        <div className="items">
          {children}
        </div>
      </div>
    </ToolWindow>
  );
};

export default withHandlers({
  handleSearchClick: ({ filterActive, onFilterActive }) => () =>
    onFilterActive(!filterActive),
})(SearchTool);



// WEBPACK FOOTER //
// ./src/components/tools/SearchTool/SearchTool.jsx